var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-6.55671e-08 16.5C-2.93554e-08 16.9142 0.335786 17.25 0.75 17.25L11.25 17.25C11.6642 17.25 12 16.9142 12 16.5C12 16.0858 11.6642 15.75 11.25 15.75L0.75 15.75C0.335786 15.75 -1.01779e-07 16.0858 -6.55671e-08 16.5Z",
    fill: "#34393E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-6.55671e-08 16.5C-2.93554e-08 16.9142 0.335786 17.25 0.75 17.25L11.25 17.25C11.6642 17.25 12 16.9142 12 16.5C12 16.0858 11.6642 15.75 11.25 15.75L0.75 15.75C0.335786 15.75 -1.01779e-07 16.0858 -6.55671e-08 16.5Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-6.55671e-08 16.5C-2.93554e-08 16.9142 0.335786 17.25 0.75 17.25L11.25 17.25C11.6642 17.25 12 16.9142 12 16.5C12 16.0858 11.6642 15.75 11.25 15.75L0.75 15.75C0.335786 15.75 -1.01779e-07 16.0858 -6.55671e-08 16.5Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9C0 8.58579 0.335786 8.25 0.75 8.25H22.25C22.6642 8.25 23 8.58579 23 9C23 9.41421 22.6642 9.75 22.25 9.75H0.75C0.335786 9.75 0 9.41421 0 9Z",
    fill: "#34393E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9C0 8.58579 0.335786 8.25 0.75 8.25H22.25C22.6642 8.25 23 8.58579 23 9C23 9.41421 22.6642 9.75 22.25 9.75H0.75C0.335786 9.75 0 9.41421 0 9Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9C0 8.58579 0.335786 8.25 0.75 8.25H22.25C22.6642 8.25 23 8.58579 23 9C23 9.41421 22.6642 9.75 22.25 9.75H0.75C0.335786 9.75 0 9.41421 0 9Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-6.55671e-08 1.5C-2.93554e-08 1.91421 0.335786 2.25 0.75 2.25L22.25 2.25C22.6642 2.25 23 1.91421 23 1.5C23 1.08578 22.6642 0.749998 22.25 0.749998L0.75 0.75C0.335786 0.75 -1.01779e-07 1.08579 -6.55671e-08 1.5Z",
    fill: "#34393E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-6.55671e-08 1.5C-2.93554e-08 1.91421 0.335786 2.25 0.75 2.25L22.25 2.25C22.6642 2.25 23 1.91421 23 1.5C23 1.08578 22.6642 0.749998 22.25 0.749998L0.75 0.75C0.335786 0.75 -1.01779e-07 1.08579 -6.55671e-08 1.5Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-6.55671e-08 1.5C-2.93554e-08 1.91421 0.335786 2.25 0.75 2.25L22.25 2.25C22.6642 2.25 23 1.91421 23 1.5C23 1.08578 22.6642 0.749998 22.25 0.749998L0.75 0.75C0.335786 0.75 -1.01779e-07 1.08579 -6.55671e-08 1.5Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.5f03fbbbf4eefe5eed6391501e61bb81.svg";
export { ForwardRef as ReactComponent };